import { SalesOrderLineItemRecord } from '@rematter/modules/trade/types/salesOrder';

export const validateLineItems = (lineItems: SalesOrderLineItemRecord[]) =>
  lineItems.reduce(
    (acc, lineItem) => {
      if (!lineItem.itemId) {
        acc[`lineItem|${lineItem.id}|itemId`] = 'required';
      }
      if (!lineItem.quantity) {
        acc[`lineItem|${lineItem.id}|weights.net`] = 'required';
      }
      return acc;
    },
    {} as Record<string, string>,
  );
